import { ThemeDefinition } from 'vuetify';

// "Greppa skolan"
export const school: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#444149',
    'on-subject-original': '#FFFFFF',
    subject: '#3A373E',
    'on-subject': '#FFFFFF',
    primary: '#323036',
    'on-primary': '#FFFFFF',
    'primary-container': '#D8D6DB',
    'on-primary-container': '#1E1D20',
    secondary: '#59585A',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D9D8D9',
    'on-secondary-container': '#1E1E1F',
    surface: '#FAFAFA',
    'on-surface': '#1E1E1F',
    'on-surface-medium': '#4C4C4D',
    'on-surface-low': '#99989A',
    outline: '#7F7E81',
    'outline-variant': '#CCCBCD',
    'inverse-surface': '#323036',
    'inverse-on-surface': '#F2F1F3',
    'inverse-primary': '#CBC9CF',
    'surface-dim': '#D5D4D9',
    'surface-bright': '#FCFCFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#EFEFF1',
    'surface-container': '#EFEFF1',
    'surface-container-high': '#E5E4E7',
    'surface-container-highest': '#E0DFE2',
  },
};

export const schoolDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#444149',
    'on-subject-original': '#FAFAFA',
    subject: '#B4B1B9',
    'on-subject': '#1E1D20',
    primary: '#D0CED4',
    'on-primary': '#1E1D20',
    'primary-container': '#4B4851',
    'on-primary-container': '#F2F1F3',
    secondary: '#CECECF',
    'on-secondary': '#1E1E1F',
    'secondary-container': '#4C4C4D',
    'on-secondary-container': '#F2F2F2',
    surface: '#141316',
    'on-surface': '#F2F2F2',
    'on-surface-medium': '#CCCBCD',
    'on-surface-low': '#7F7E81',
    outline: '#99989A',
    'outline-variant': '#666567',
    'inverse-surface': '#E5E4E7',
    'inverse-on-surface': '#1E1D20',
    'inverse-primary': '#323036',
    'surface-dim': '#111113',
    'surface-bright': '#39373E',
    'surface-container-lowest': '#0F0E10',
    'surface-container-low': '#19181B',
    'surface-container': '#201F23',
    'surface-container-high': '#2A292E',
    'surface-container-highest': '#37353B',
  },
};
